import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 3C10.2558 3 8.51473 3.5897 6.95233 5.01006C5.40976 6.4124 4.08489 8.58305 3.05132 11.6838C2.94308 12.0085 2.84207 12.3323 2.74211 12.6528C2.51032 13.3958 2.28416 14.1209 1.98648 14.7974C1.55829 15.7706 1.10902 16.3199 0.618354 16.5225L0 16.7778V21H9V14C9 12.3431 10.3431 11 12 11C13.6569 11 15 12.3431 15 14V21H24V16.7778L23.3816 16.5225C22.891 16.3199 22.4417 15.7706 22.0135 14.7974C21.7158 14.1209 21.4897 13.3959 21.2579 12.6528C21.158 12.3324 21.0569 12.0084 20.9487 11.6838C19.9151 8.58305 18.5902 6.4124 17.0477 5.01006C15.4853 3.5897 13.7442 3 12 3Z"}}]};

const Bridge2Filled = Vue.extend<IconProps>({
  name: 'Bridge2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bridge-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Bridge2Filled;
